module.exports = __webpack_public_path__ + "static/media/origin-snap.f7545044.png";